import { FormConfig, formStatus } from "../../records/Form";
import * as actionTypes from "./actionTypes";
import { Actions, JsonPatchAction } from "./types";

//--------------------------
// Action Creators
//--------------------------

/**
 * Creates a new empty form in ui state
 * @param {string} fid form id
 */
// TODO: type
export function newForm(fid: string, data: FormConfig): Actions {
	return { type: actionTypes.FORM_NEW, fid: fid, data: data };
}

/**
 * Merge updated form data into a form currently held in state
 * @param fid string
 * @param update FormConfig
 */
export function mergeUpdate(fid: string, update: FormConfig): Actions {
	return { type: actionTypes.FORM_MERGE_UPDATE, fid: fid, update: update };
}

/**
 * Ready
 * everything is A okay, we have everything we need to render the form, no updates
 * are happening and no errors
 * @param {string} fid form id
 */
export function statusReady(fid: string): Actions {
	return {
		type: actionTypes.FORM_STATUS_UPDATE,
		fid: fid,
		status: formStatus.ready,
	};
}

/**
 * Loading - default form status
 * a form with a status of loading will not render elements, a spinner will be shown
 * @param {string} fid form id
 */
export function statusLoading(fid: string): Actions {
	return {
		type: actionTypes.FORM_STATUS_UPDATE,
		fid: fid,
		status: formStatus.loading,
	};
}

/**
 * Error - generally used to flag api errors
 * will stop rendering elements and show an error message
 * @param {string} fid form id
 */
export function statusError(fid: string, message?: string): Actions {
	return {
		type: actionTypes.FORM_STATUS_UPDATE,
		fid: fid,
		status: formStatus.error,
		message,
	};
}

/**
 * Closed - when a form has been closed but not yet removed from state
 * @param {string} fid form id
 */
export function statusClosed(fid: string): Actions {
	return {
		type: actionTypes.FORM_STATUS_UPDATE,
		fid: fid,
		status: formStatus.closed,
	};
}

/**
 * Updating - when the form is pushing / pulling data to and from the api
 * the form will still render with this status but we can use this status to potentially
 * render some kind of graphic to show the user that an update is occuring
 */
export function statusUpdating(fid: string): Actions {
	return {
		type: actionTypes.FORM_STATUS_UPDATE,
		fid: fid,
		status: formStatus.updating,
	};
}

/**
 * Destroy a form
 * @param {string} fid form id
 */
export function removeForm(fid: string): Actions {
	return { type: actionTypes.FORM_REMOVE, fid: fid };
}

// NEW
export function sendPatches(fid: string): Actions {
	return { type: actionTypes.SEND_PATCHES, fid };
}

export function getLatest(fid: string): Actions {
	return {
		type: actionTypes.FORM_GET,
		fid,
	};
}

export function save(
	fid: string,
	tid?: string,
	updateTaskName?: (taskName: string) => void
): Actions {
	return {
		type: actionTypes.FORM_SAVE,
		fid,
		tid,
		updateTaskName,
	};
}

export function saveAndClose(fid: string): Actions {
	return {
		type: actionTypes.FORM_SAVE_CLOSE,
		fid,
	};
}

export function close(fid: string): Actions {
	return {
		type: actionTypes.FORM_CLOSE,
		fid,
	};
}

export function jsonPatch(
	fid: string,
	patch: JsonPatchAction["patch"]
): Actions {
	return {
		type: actionTypes.JSON_PATCH,
		fid,
		patch,
	};
}

export function jsonPatchSuccess(
	fid: string,
	update: FormConfig,
	clearPatches: number
): Actions {
	return {
		type: actionTypes.JSON_PATCH_SUCCESS,
		fid: fid,
		update: update,
		clearPatches,
	};
}

export function setMessage(fid: string, message: string): Actions {
	return {
		type: actionTypes.FORM_SET_MESSAGE,
		fid,
		message,
	};
}

export function clearMessage(fid: string): Actions {
	return {
		type: actionTypes.FORM_CLEAR_MESSAGE,
		fid,
	};
}
